module.exports = __webpack_public_path__ + "static/media/visa_voorbeeld.28879236.png";